import { BoxProps, Typography } from '@material-ui/core'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import styled from 'styled-components'
import { Pill } from 'common/atoms/Pill/Pill'

interface IJobDetailsPillProps extends BoxProps {
  job?: any
  text?: string
}

export const JobDetailsPill = ({ job, text, ...rest }: IJobDetailsPillProps) => {
  const { isDevice } = useScreenSizes()
  return (
    <Pill small text={text} />
  )
}
